import React from 'react';
import { Link } from 'react-router-dom';
import { FaLink, FaQrcode, FaBabyCarriage, FaArrowRight, FaLaptop } from 'react-icons/fa';
import usePageMeta from '../hooks/usePageMeta';
import './FreeSolutions.css';

interface FreeTool {
  icon: React.ReactNode;
  title: string;
  description: string;
  to: string;
  cta: string;
}

const tools: FreeTool[] = [
  {
    icon: <FaLink />,
    title: 'Gerador de Link WhatsApp',
    description:
      'Crie links de WhatsApp com mensagem pronta em segundos. Ideal para divulgar seu contato em redes sociais, site e materiais impressos.',
    to: '/free-tools/whatsapp-link-generator',
    cta: 'Gerar link',
  },
  {
    icon: <FaQrcode />,
    title: 'Gerador de QR Code',
    description:
      'Gere QR Codes para links, Wi-Fi, vCard, e-mail, SMS e WhatsApp. Personalize as cores e baixe em alta resolução, sem custo.',
    to: '/free-tools/qr-code-generator',
    cta: 'Criar QR Code',
  },
  {
    icon: <FaBabyCarriage />,
    title: 'UpdateCommit Baby',
    description:
      'Crie a vaquinha e a lista de presentes do seu bebê. Compartilhe com amigos e família e receba contribuições via PIX direto na sua conta.',
    to: '/solucoes/baby',
    cta: 'Conhecer',
  },
];

const FreeSolutions: React.FC = () => {
  usePageMeta({
    title: 'Ferramentas Gratuitas',
    description:
      'Ferramentas gratuitas da UpdateCommit: gerador de link para WhatsApp, gerador de QR Code e UpdateCommit Baby. Use sem cadastro e sem custo.',
    path: '/free-solutions',
  });

  return (
    <div className="free-solutions-page">
      <section className="free-solutions-hero">
        <span className="free-solutions-badge">✨ 100% gratuito</span>
        <h1 className="free-solutions-title">Ferramentas Gratuitas</h1>
        <p className="free-solutions-subtitle">
          Ferramentas simples e úteis que criamos para o dia a dia do seu negócio.
          Sem cadastro, sem custo, sem pegadinha.
        </p>
      </section>

      <section className="free-solutions-grid reveal">
        {tools.map((tool) => (
          <Link key={tool.to} to={tool.to} className="free-solutions-card">
            <div className="free-solutions-card-icon">{tool.icon}</div>
            <h2 className="free-solutions-card-title">{tool.title}</h2>
            <p className="free-solutions-card-description">{tool.description}</p>
            <span className="free-solutions-card-cta">
              {tool.cta} <FaArrowRight />
            </span>
          </Link>
        ))}
      </section>

      <section className="free-solutions-cta reveal reveal--scale">
        <div className="free-solutions-cta-card">
          <div className="free-solutions-cta-icon">
            <FaLaptop />
          </div>
          <div className="free-solutions-cta-text">
            <h2>Precisa de algo sob medida?</h2>
            <p>
              Desenvolvemos sistemas, integrações e automações personalizadas para o seu negócio.
            </p>
          </div>
          <Link to="/custom-solutions" className="free-solutions-cta-button">
            Conte seu projeto <FaArrowRight />
          </Link>
        </div>
      </section>
    </div>
  );
};

export default FreeSolutions;
